import styled from 'styled-components';

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  margin-top: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }
`;

export const PlanCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
  height: fit-content;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    padding: 20px;
    min-height: 260px;
  }
`;

export const CardHeader = styled.div`
  margin-bottom: 16px;
  flex-shrink: 0;
`;

export const CardInfo = styled.div`
  margin-bottom: 20px;
  flex: 1;
`;

export const CardStats = styled.div`
  margin-bottom: 16px;
  flex-shrink: 0;
`;

export const CardActions = styled.div`
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
  flex-shrink: 0;
`;

// Keep the old StyledBadge for backward compatibility if needed elsewhere
export const StyledBadge = styled.div`
  height: 20px;
  min-width: 80px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary};
  padding: 0 8px;

  & > span {
    font-size: 0.75rem;
    font-weight: 500;
    color: white;
    line-height: 20px;
    text-align: center;
    white-space: nowrap;
  }
`;
